import CrudActionSetBase from './CrudActionSetBase'

export class MeterDataFileActionSet extends CrudActionSetBase('meterDataFile'){
}

export default new MeterDataFileActionSet()
